import { render } from "./BancosList.vue?vue&type=template&id=9f5a9eb0&scoped=true"
import script from "./BancosList.vue?vue&type=script&lang=js"
export * from "./BancosList.vue?vue&type=script&lang=js"

import "./BancosList.vue?vue&type=style&index=0&id=9f5a9eb0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f5a9eb0"]])

export default __exports__